export default __webpack_public_path__ + "static/media/HowItWorks_Step1_TC.9b2c8dd9.png";